const left_swiper = new Swiper(".swiper-left-wrap.swiper", {
  loop: true,
  slidesPerView: "1",
  freeMode: true,
  freeModeMomentum: false,
  speed: 5000,
  allowTouchMove: true,
  pagination: {
    el: ".swiper-pagination-left",
    dynamicBullets: true,
  },
});

const right_swiper = new Swiper(".swiper-right-wrap.swiper", {
  loop: true,
  slidesPerView: "1",
  freeMode: true,
  freeModeMomentum: false,
  speed: 5000,
  allowTouchMove: true,
  pagination: {
    el: ".swiper-pagination-right",
    dynamicBullets: true,
  },
});
